$(document).on('click','.load-more-btn', function (e) {
  e.preventDefault();
  var items_to_show = $('.family-blog').attr('data-initial');
  console.log(items_to_show);
  $('.family-blog-card:hidden').each((index, card) => {
    if (index < items_to_show) {
      $(card).addClass('d-block');
    }
  })
  if ($('.family-blog-card:hidden').length == 0) {
    $('.load-more-btn').parent().remove();
  }
});